import {
  Box,
  Button,
  Card,
  IconButton,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Grid2 from "@mui/material/Grid2";
import YourBookingCard from "./YourBookingCard";
import { useDispatch, useSelector } from "react-redux";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import { format_Number } from "../../utils/utils";
import {
  setCombinationQTY,
  setSelectedCombination,
} from "../../store/slice/Activity.slice";
import PaymentCard from "./PaymentCard";
import AddressCard from "./AddressCard";
import CombinationCard from "./CombinationCard";
import CardSection from "./CardSection";
import ExpandLessTwoToneIcon from "@mui/icons-material/ExpandLessTwoTone";
import ExpandMoreTwoToneIcon from "@mui/icons-material/ExpandMoreTwoTone";

const Combination = ({
  totalCount,
  languageWords,
  reservType,
  selectedDate,
  adult,
  child,
  kid,
  baby,
  toddler,
  selectedExtraProduct,
  time,
  transactionDetails,
  transactionPrice,
  excludingVat,
  totalVat,
  totalIncludingVAT,
  totalCostYourBooking,
}) => {
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { selectedCombination, combinationQTY, combinationList } = useSelector(
    (store) => store.Activity
  );
 
  const [isShowMore, setIsShowMore] = useState(false);
  const productsToDisplay =
    combinationList?.length > 0
      ? isShowMore
        ? combinationList
        : combinationList?.slice(0, 2)
      : [];
  const { widgetConfig } = useSelector((store) => store?.widgetSettings);
  useEffect(() => {
    if (Object.keys(combinationQTY).length > 0) return;
    const obj = combinationList?.reduce(
      (acc, red) => ({
        ...acc,
        [red.idreservationtype + String(red.isBefore)]: 1,
      }),
      {}
    );
    dispatch(setCombinationQTY(obj));
  }, [combinationList]);
  const handleCombinationsSelect = (item) => {
    const key = item?.idreservationtype + String(item.isBefore); // Match your existing format

    const isAlreadySelected = selectedCombination?.some(
      (prod) =>
        prod.idreservationtype === item?.idreservationtype &&
        prod.arrivalTime === item?.arrivalTime &&
        prod.depatureTime === item?.depatureTime &&
        prod.isBefore === item?.isBefore
    );

    if (isAlreadySelected) {
      // Just remove from selectedCombination, keep qty as is
      dispatch(
        setSelectedCombination(
          selectedCombination.filter(
            (prod) =>
              !(
                prod.idreservationtype === item?.idreservationtype &&
                prod.arrivalTime === item?.arrivalTime &&
                prod.depatureTime === item?.depatureTime &&
                prod.isBefore === item?.isBefore
              )
          )
        )
      );
      dispatch(
        setCombinationQTY((prev) => ({
          ...prev,
          [key]: 1,
        }))
      );
    } else {
      if (selectedCombination.length >= 2) return;

      dispatch(setSelectedCombination([...selectedCombination, item]));

      // Only set qty if it doesn't exist already
      dispatch(
        setCombinationQTY((prev) => ({
          ...prev,
          [key]: prev[key] || 1,
        }))
      );
    }
  };
  const handleIncrement = (item) => {
    const key = item?.idreservationtype + String(item.isBefore);

    const isAlreadySelected = selectedCombination?.some(
      (prod) =>
        prod.idreservationtype === item?.idreservationtype &&
        prod.arrivalTime === item?.arrivalTime &&
        prod.depatureTime === item?.depatureTime &&
        prod.isBefore === item?.isBefore
    );

    // Ensure item is selected
    if (!isAlreadySelected) {
      if (selectedCombination.length >= 2) return;
      dispatch(setSelectedCombination([...selectedCombination, item]));
    }

    if (combinationQTY[key] >= item?.tableCount) return;

    dispatch(
      setCombinationQTY((prev) => ({
        ...prev,
        [key]: (prev[key] || 0) + 1,
      }))
    );
  };
  const handleDecrement = (item) => {
    const key = item?.idreservationtype + String(item.isBefore);

    if (!combinationQTY[key] || combinationQTY[key] <= 1) return;

    dispatch(
      setCombinationQTY((prev) => ({
        ...prev,
        [key]: prev[key] - 1,
      }))
    );
  };
  function convertToMinutes(time) {
    if (!time) return 0;
    const [hours, minutes] = time.split(":").map(Number);
    return hours * 60 + minutes;
  }
  return (
    <Box sx={{ p: 2 }}>
      <Grid2 container spacing={2}>
        <Grid2 size={{ md: 9, sm: 12, xs: 12 }} sx={{ mt: 3 }}>
          {loading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
              }}
            ></Box>
          ) : (
            <Box sx={{ width: "100%", minHeight: "250px" }}>
              <Box>
                <Typography
                  sx={{
                    color: "#000000",
                    fontSize: { md: "28px", sm: "19px", xs: "16px" },
                  }}
                >
                  {languageWords?.Bowling}
                </Typography>
                <Typography
                  sx={{ fontSize: "12px", color: "#969BA0", mt: 2, mb: 2 }}
                >
                  {languageWords?.CombinationInfo}
                </Typography>
              </Box>
              {productsToDisplay?.map((item, index) => {
                const isDisabled = selectedCombination?.some((selected) => {
                  // Skip disabling for the selected item (even if it overlaps)
                  if (
                    selected.idreservationtype === item.idreservationtype &&
                    selected.arrivalTime === item.arrivalTime &&
                    selected.depatureTime === item.depatureTime
                  ) {
                    return false; // Don't disable the selected item
                  }

                  const selectedArrival = convertToMinutes(
                    selected.arrivalTime
                  );
                  const selectedDeparture = convertToMinutes(
                    selected.depatureTime
                  );
                  const itemArrival = convertToMinutes(item.arrivalTime);
                  const itemDeparture = convertToMinutes(item.depatureTime);

                  // Check for overlapping time ranges (skip the selected item)
                  return (
                    (itemArrival >= selectedArrival &&
                      itemArrival < selectedDeparture) ||
                    (itemDeparture > selectedArrival &&
                      itemDeparture <= selectedDeparture) ||
                    (itemArrival <= selectedArrival &&
                      itemDeparture >= selectedDeparture)
                  );
                });

                return (
                  <Grid2
                    container
                    key={
                      item?.idreservationtype + String(item?.isBefore) + index
                    }
                    sx={{
                      display: isDisabled ? "none" : "relative",
                      position: "relative",
                      // display: "flex",
                      // flexDirection: { xs: "column", sm: "row" }, // Stack vertically on xs and horizontally on sm+
                      gap: "1rem",
                      border: "1px solid #EBEBEB",
                      p: 2,
                      borderRadius: "5px",
                      backgroundColor: selectedCombination?.some(
                        (product) =>
                          product.idreservationtype ===
                            item.idreservationtype &&
                          product?.arrivalTime == item?.arrivalTime &&
                          product?.depatureTime == item?.depatureTime
                      )
                        ? theme?.product?.bgActive
                        : theme?.product?.bgColor,
                      mb: 2,
                      boxShadow: "rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px",
                      width: "100%", // Full width for all screen sizes
                      opacity: isDisabled ? 0.5 : 1, // Visually indicate disabled state
                      pointerEvents: isDisabled ? "none" : "auto", // Disable user interaction if needed
                    }}
                    // key={item?.idreservationtype+item?.arrivalTime+item.depatureTime}
                  >
                    {item?.imageFilePath && (
                      <Grid2
                        size={{ md: 3, sm: 3, xs: 12 }}
                        sx={{
                          width: "100%",
                          height: "100%", // Maintain 5:4 aspect ratio (width × 0.8)
                          borderRadius: "5px",
                          overflow: "hidden", // Prevent image overflow
                        }}
                      >
                        <img
                          src={item?.imageFilePath}
                          alt="extra-img"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain", // Ensures the image fills the container while maintaining aspect ratio
                          }} // Ensure proper scaling of the image
                        />
                      </Grid2>
                    )}
                    <Grid2
                      size={{
                        md: item?.imageFilePath ? 8 : 11,
                        sm: item?.imageFilePath ? 8 : 12,
                        xs: 12,
                      }}
                    >
                      <Box sx={{ width: "100%" }}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between", // Ensure price is pushed to the right
                            alignItems: "center",
                            width: "100%", // Ensures full width

                            mb: 1,
                          }}
                        >
                          <Typography
                            sx={{
                              color: selectedCombination?.some(
                                (product) =>
                                  product.idreservationtype ===
                                    item.idreservationtype &&
                                  product?.arrivalTime == item?.arrivalTime
                              )
                                ? theme?.product?.headerActive
                                : theme?.product?.headerColor,
                              fontSize: { md: "1.5rem", sm: "14px" },
                              fontWeight: "semiBold",
                            }}
                          >
                            {item?.reservationType}
                            <small
                              style={{
                                color: selectedCombination?.some(
                                  (product) =>
                                    product.idreservationtype +
                                      String(product?.isBefore) ==
                                    item.idreservationtype +
                                      String(item?.isBefore)
                                )
                                  ? theme?.product?.priceColorActive
                                  : theme?.product?.priceColor,
                                fontSize: "15px",
                                marginLeft: "0.6rem",
                              }}
                            >
                              {item?.isBefore
                                ? `${languageWords?.before || "Before"} ${
                                    reservType?.name
                                  }`
                                : `${languageWords?.after || "After"} ${
                                    reservType?.name
                                  }`}
                            </small>
                          </Typography>

                          {/* Move this Typography inside the Box correctly */}
                          {item?.price > 0 && (
                            <Typography
                              sx={{
                                color: selectedCombination?.some(
                                  (product) =>
                                    product.idreservationtype ===
                                      item.idreservationtype &&
                                    product?.arrivalTime == item?.arrivalTime
                                )
                                  ? theme?.product?.priceColorActive
                                  : theme?.product?.priceColor,
                                fontSize: { md: "20px", sm: "14px" },
                                fontWeight: "semiBold",
                                textAlign: "right", // Ensures it's aligned to the right
                              }}
                            >
                              €
                              {format_Number(
                                item?.price *
                                  combinationQTY[
                                    item.idreservationtype +
                                      String(item?.isBefore)
                                  ]
                              )}
                            </Typography>
                          )}
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            gap: "1rem",
                            alignItems: "center",
                          }}
                        >
                          <AccessTimeIcon
                            sx={{
                              color: selectedCombination?.some(
                                (product) =>
                                  product.idreservationtype ===
                                    item.idreservationtype &&
                                  product?.arrivalTime == item?.arrivalTime
                              )
                                ? "#fff"
                                : "#969BA0",
                            }}
                          />
                          <Typography
                            sx={{
                              color: selectedCombination?.some(
                                (product) =>
                                  product.idreservationtype ===
                                    item.idreservationtype &&
                                  product?.arrivalTime == item?.arrivalTime
                              )
                                ? "#fff"
                                : "#969BA0",
                            }}
                          >{`${item?.arrivalTime?.substring(
                            0,
                            5
                          )} - ${item?.depatureTime?.substring(
                            0,
                            5
                          )}`}</Typography>
                        </Box>

                        <Typography
                          sx={{
                            color: selectedCombination?.some(
                              (product) =>
                                product.idreservationtype ===
                                  item.idreservationtype &&
                                product?.arrivalTime == item?.arrivalTime
                            )
                              ? "#fff"
                              : "#969BA0",
                            fontSize: "14px",
                            mt: 2,
                          }}
                        >
                          {item?.reservationTypeInfo}
                        </Typography>
                        <Box
                          sx={{
                            // position:"absolute",
                            // right:10,
                            // bottom:10,

                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            mt: 2,
                            gap: "1rem",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-end",
                              mt: 2,
                              gap: "1rem",
                            }}
                          >
                            <Button
                              onClick={() =>
                                // handleDecrement(item?.idreservationtype+String(item.isBefore))
                                handleDecrement(item)
                              }
                              //   disabled={(quantities[item.idproduct] || 1) === 1} // Disable if quantity is 0
                              sx={{
                                minWidth: "30px",
                                color: selectedCombination?.some(
                                  (product) =>
                                    product.idreservationtype ===
                                      item.idreservationtype &&
                                    product?.arrivalTime == item?.arrivalTime
                                )
                                  ? "#fff"
                                  : "#000000",
                              }}
                            >
                              -
                            </Button>
                            <Typography
                              sx={{
                                color: selectedCombination?.some(
                                  (product) =>
                                    product.idreservationtype ===
                                      item.idreservationtype &&
                                    product?.arrivalTime == item?.arrivalTime
                                )
                                  ? "#fff"
                                  : "black",
                              }}
                            >
                              {combinationQTY[
                                item?.idreservationtype + String(item.isBefore)
                              ] ?? 0}
                            </Typography>

                            <Button
                              onClick={() => handleIncrement(item)}
                              sx={{
                                minWidth: "30px",
                                color: selectedCombination?.some(
                                  (product) =>
                                    product.idreservationtype ===
                                      item.idreservationtype &&
                                    product?.arrivalTime == item?.arrivalTime
                                )
                                  ? "#fff"
                                  : "#000000",
                              }}
                              disabled={
                                combinationQTY[
                                  item?.idreservationtype +
                                    String(item.isBefore)
                                ] >= item?.tableCount
                              }
                            >
                              +
                            </Button>
                            <IconButton
                              size={"large"}
                              onClick={() => handleCombinationsSelect(item)}
                              sx={{
                                borderRadius: "5px",
                              }}
                              color={
                                selectedCombination?.some(
                                  (product) =>
                                    product.idreservationtype ===
                                      item.idreservationtype &&
                                    product?.arrivalTime == item?.arrivalTime
                                )
                                  ? theme?.product?.addBtnTextActive
                                  : theme?.product?.addBtnTextColor
                              }
                            >
                              {selectedCombination?.some(
                                (product) =>
                                  product.idreservationtype ===
                                    item.idreservationtype &&
                                  product?.arrivalTime == item?.arrivalTime
                              ) ? (
                                <RemoveCircleIcon />
                              ) : (
                                <AddCircleIcon />
                              )}
                            </IconButton>
                          </Box>
                        </Box>
                      </Box>
                    </Grid2>
                  </Grid2>
                );
              })}
            </Box>
          )}
          {combinationList.length > 4 && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <IconButton
                sx={{
                  backgroundColor: theme?.product?.addBtnBg,
                  fontSize: "14px",
                  color: theme?.product?.addBtnTextColor,

                  "&:hover": {
                    backgroundColor: theme?.product?.addBtnBgHover,
                    color: theme?.product?.addBtnTextHover,
                  },
                }}
                onClick={() => setIsShowMore(!isShowMore)}
              >
                {!isShowMore ? (
                  <ExpandMoreTwoToneIcon />
                ) : (
                  <ExpandLessTwoToneIcon />
                )}
              </IconButton>
            </Box>
          )}
        </Grid2>
        <Grid2 size={{ md: 3, sm: 12, xs: 12 }} sx={{ mt: 3 }}>
          <CardSection
            totalCount={totalCount}
            languageWords={languageWords}
            reservType={reservType}
            selectedDate={selectedDate}
            adult={adult}
            child={child}
            kid={kid}
            baby={baby}
            toddler={toddler}
            selectedExtraProduct={selectedExtraProduct}
            time={time}
            transactionDetails={transactionDetails}
            selectedCombination={selectedCombination}
            transactionPrice={transactionPrice}
            excludingVat={excludingVat}
            totalVat={totalVat}
            totalIncludingVAT={totalIncludingVAT}
            totalCostYourBooking={totalCostYourBooking}
          />
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default Combination;
